/* Page helpers: search results tabs + sort auto-submit. Loaded with `defer` by main-search.liquid. */
(() => {
  'use strict';
  if (window.__purrPagesBound) return;
  window.__purrPagesBound = true;
  const Purr = window.Purr || {};

  /* ----- Tabs (role=tablist / tab / tabpanel) ----- */
  const initTabs = (root) => {
    const list = root.querySelector('[role="tablist"]');
    if (!list || list.dataset.ready) return;
    list.dataset.ready = 'true';
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    const panels = tabs.map((t) => document.getElementById(t.getAttribute('aria-controls'))).filter(Boolean);
    if (!tabs.length) return;

    const activate = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      if (tab.dataset.tab) {
        try {
          const u = new URL(window.location.href);
          if (tab.dataset.tab === tabs[0].dataset.tab) u.searchParams.delete('tab'); else u.searchParams.set('tab', tab.dataset.tab);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => { e.preventDefault(); activate(tab, false); });
      tab.addEventListener('keydown', (e) => {
        const i = tabs.indexOf(tab);
        let next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activate(next, true); }
      });
    });

    // Initial tab: ?tab= param → tab flagged aria-selected in markup → first tab with results → first tab.
    let initial = null;
    try { const wanted = new URL(window.location.href).searchParams.get('tab'); if (wanted) initial = tabs.find((t) => t.dataset.tab === wanted); } catch (e) { /* ignore */ }
    if (!initial) initial = tabs.find((t) => t.getAttribute('aria-selected') === 'true');
    if (!initial) initial = tabs.find((t) => parseInt(t.dataset.count || '0', 10) > 0) || tabs[0];
    panels.forEach((p) => { p.hidden = true; });
    activate(initial, false);
  };

  /* ----- Sort select auto-submit ----- */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-sort-select]');
    if (!select) return;
    const form = select.form || select.closest('form');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
  });

  const init = () => document.querySelectorAll('[data-purr-tabs]').forEach(initTabs);
  if (typeof Purr.ready === 'function') Purr.ready(init); else if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
